'use client'

import { Crown } from 'lucide-react'
import { memo } from 'react'

import { PRIME_CHIP_RING_CLASS } from './primeStyles'
import { Badge } from '@fp/ui-kit'
import { usePrimeMode } from '@hooks/usePrimeMode'

interface PrimeChipProps {
  className?: string
}

export const PrimeChip = memo(({ className }: PrimeChipProps) => {
  const isPrimeMode = usePrimeMode()

  if (!isPrimeMode) return null

  return (
    <Badge
      role='status'
      variant='prime'
      className={`!rounded-full !bg-transparent hover:!bg-transparent !text-foreground !font-normal !gap-1.5 ${PRIME_CHIP_RING_CLASS} ${className ?? ''}`}
    >
      <Crown size={13} className='fill-[var(--prime)] text-prime' />
      Prime accounts
    </Badge>
  )
})

PrimeChip.displayName = 'PrimeChip'
